"use client"

import { useEffect, useState } from "react"

import { ToastContainer as StyledToastContainer } from "./styled"

/**
 * Toast component description displayed in storybook
 */
export const ToastContainer = () => {
  const [navigationWidth, setNavigationWidth] = useState(0)

  useEffect(() => {
    const navigation = document.querySelector("aside")
    navigation && setNavigationWidth(navigation.offsetWidth)
  }, [])

  return <StyledToastContainer position="top-center" theme="dark" autoClose={3000} $navigationWidth={navigationWidth} />
}
